import React, { useState } from 'react';
import { Empty } from 'antd';

import { Mask, MasksConfig } from 'types';
import StyledTable from 'components/organisms/styled-table';
import EditMaskModal from 'components/organisms/edit-mask-modal';
import { useIntl } from 'common/config/i18n';

import ExpandedRowRender from './expandable-row';

type Props = {
  data: Mask[];
  dataConfig: MasksConfig;
  isAdmin: boolean;
};

const MaskTable: React.FC<Props> = ({ data, dataConfig, isAdmin }: Props) => {
  const { t } = useIntl();

  const [rowkeys, setRowKeys] = useState<Record<string, boolean>>({});
  const [modalMaskId, setModalMaskId] = useState<number | undefined>(undefined);

  const columns = [
    {
      title: t('table', 'CHART_PROCESS_SITUATION'),
      dataIndex: 'situationName',
      key: 'situationName',
    },
  ];

  const oneExpand = (toggled: boolean, cellRecord: Mask) => {
    const nextRowKeys: typeof rowkeys = {
      ...rowkeys,
      [cellRecord.situationName]: toggled,
    };
    setRowKeys(nextRowKeys);
  };

  const expandedRowKeys = Object.entries(rowkeys)
    .filter(([_, value]) => !!value)
    .map(([key]) => key);

  const isModalOpen = !!modalMaskId || modalMaskId === 0;

  return (
    <>
      {isModalOpen && (
        <EditMaskModal maskId={modalMaskId} isOpen={isModalOpen} onClose={() => setModalMaskId(undefined)} />
      )}
      {
        <StyledTable
          rowKey="situationName" /* We use situationName as a key */
          className="table-striped-rows"
          columns={columns}
          dataSource={data}
          pagination={false}
          locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
          expandable={{
            expandedRowRender: (record) => (
              <ExpandedRowRender
                rowData={record as Mask}
                isAdmin={isAdmin}
                config={dataConfig}
                onEdit={(id: number) => setModalMaskId(id)}
              />
            ),
          }}
          onExpand={(expanded, record) => oneExpand(expanded, record as Mask)}
          expandedRowKeys={expandedRowKeys}
        />
      }
    </>
  );
};

export default MaskTable;
